import { Box, useColorMode } from '@chakra-ui/react'
import { AnimatePresence, motion } from 'framer-motion'
import React, { useCallback, useContext } from 'react'
import Particles from 'react-tsparticles'
import { loadSlim } from 'tsparticles-slim'
import backgroundContext from '../context/backgroundContext'
import { getTokens } from '../config/colorTokens'

const MotionBox = motion(Box)

const Background = () => {
	const particlesInit = useCallback(async (engine) => {
		await loadSlim(engine)
	}, [])

	const { colorMode } = useColorMode()
	const context = useContext(backgroundContext)
	const { showBackground } = context
	const t = getTokens(colorMode)

	return (
		<Box
			position="fixed"
			top={0}
			left={0}
			right={0}
			bottom={0}
			zIndex={-1}
			overflow="hidden"
			pointerEvents="none"
			bg={t.bg}
			transition="background-color 0.4s cubic-bezier(0.4, 0, 0.2, 1)">
			<AnimatePresence>
				{showBackground && (
					<MotionBox
						key="particles"
						position="absolute"
						inset={0}
						initial={{ opacity: 0 }}
						animate={{ opacity: 1 }}
						exit={{ opacity: 0 }}
						transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}>
						<Particles
							id="tsparticles"
							init={particlesInit}
							options={{
								fpsLimit: 120,
								interactivity: {
									events: {
										onHover: {
											enable: true,
											mode: 'grab'
										},
										resize: true
									},
									modes: {
										grab: {
											distance: 140,
											links: {
												opacity: 0.5
											}
										}
									}
								},
								particles: {
									color: {
										value: t.particle
									},
									links: {
										color: t.particle,
										distance: 150,
										enable: true,
										opacity: 0.2,
										width: 1
									},
									move: {
										direction: 'none',
										enable: true,
										outModes: {
											default: 'out'
										},
										random: false,
										speed: 0.8,
										straight: false
									},
									number: {
										density: {
											enable: true,
											area: 800
										},
										value: 40
									},
									opacity: {
										value: { min: 0.1, max: 0.5 },
										animation: {
											enable: true,
											speed: 1,
											minimumValue: 0.1
										}
									},
									shape: {
										type: 'circle'
									},
									size: {
										value: { min: 1, max: 3 }
									}
								},
								detectRetina: true
							}}
						/>
					</MotionBox>
				)}
			</AnimatePresence>
		</Box>
	)
}

export default Background
